/* @ngInject */
const myNewPassword = (
  valueHandler
) => {
  return {
    restrict: 'E',
    scope: {
      myRequired: '=?',
      myDisabled: '=?',
      myPassword: '=',
    },
    template: require('./myNewPassword.html'),

    /* @ngInject */
    controller: ($scope) => {
      $scope.$watch('myPassword', (value) => {
        if (valueHandler.isEmpty(value)) {
          $scope.passwordConfirmation = null
        }
      })
    },

    link: (scope, element, attrs, ctrl) => {

    },
  }
}

export default myNewPassword



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/inputs/myNewPassword.js